export const fmtARS = (n) => `$ ${Math.round(Number(n) || 0).toLocaleString('es-AR')}`;
